<template>
  <div>
    <a class="action ant-dropdown-link user-dropdown-menu" v-if="peopletype == '00'" @click="showamountEnterprise">
      <span class="size-10 mr-2"></span><a-icon type="search" />
    </a>
    <a-modal width="85%" v-model="leafletsible" style="top: 20px" footer="" title="企业金额信息">
      <div class="table-page-search-wrapper">
        <a-form layout="inline" :form="form">
          <a-row>
            <a-col :span="5">
              <a-form-item label="企业名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-select
                  showSearch
                  v-model="enterpriseId"
                  optionFilterProp="children"
                  :filterOption="filterOption"
                  :allowClear="true"
                >
                  <a-select-option
                    v-for="type in selectCombox"
                    :title="type.enterpriseName"
                    :key="type.enterpriseId"
                  >{{ type.enterpriseName }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="2">
              <a-button
                type="primary"
                style="margin-left: 10px"
                @click="allViewamount"
                :disabled="enterpriseId ? false : true"
              >
                查看金额
              </a-button>
            </a-col>
            <a-col :span="2">
              <a-button
                type="primary"
                style="margin-left: 10px"
                @click="allView"
                :disabled="enterpriseId ? false : true"
              >
                企业要求
              </a-button>
            </a-col>
          </a-row>

          <a-row>
            <a-col :span="24">
              <div style="display: flex">
                <a-col :span="5" v-if="installTypes.length > 0">
                  <a-form-item label="安装类别">
                    <a-select
                      v-decorator="[
                        'installType',
                        { initialValue: this.installTypes[0].dictValue },
                        { rules: [{ required: true, message: '选择安装类别!' }] },
                      ]"
                      @change="getinstallType"
                    >
                      <a-select-option v-for="type in installTypes" :title="type.dictLabel" :key="type.dictValue">{{
                        type.dictLabel
                      }}</a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :span="5">
                  <a-form-item label="姓名/电话" style="margin-left: 8px">
                    <a-input v-decorator="['nameOrPhone']" />
                  </a-form-item>
                </a-col>
                <a-col :span="4">
                  <a-form-item label="省" style="margin-left: 8px">
                    <a-select @change="getselect" :allowClear="true" v-decorator="['provinceId']">
                      <a-select-option v-for="type in selectAllProvince" :key="type.provinceCode">
                        {{ type.provinceName }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :span="4">
                  <a-form-item label="市" style="margin-left: 8px">
                    <a-select v-decorator="['cityId']" @change="getprovinceName" :allowClear="true">
                      <a-select-option v-for="type in selectCityName" :key="type.cityCode">
                        {{ type.cityName }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :span="4">
                  <a-form-item label="区" style="margin-left: 8px">
                    <a-select v-decorator="['countyId']" :allowClear="true">
                      <a-select-option v-for="type in selectAreaName" :key="type.areaCode">
                        {{ type.areaName }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>

                <a-col :span="2">
                  <a-form-item label="" style="width: 250px">
                    <a-button type="primary" style="margin-left: 10px" @click="masterQuery"> 查询师傅 </a-button>
                  </a-form-item>
                </a-col>
              </div>
            </a-col>
          </a-row>
          <a-table
            size="default"
            ref="table"
            rowKey="orderId"
            :columns="distributecolumns"
            :dataSource="this.distributedata"
            bordered
            :pagination="false"
            :scroll="{ x: 1800 }"
          >
            <span slot="totalScore" slot-scope="text, record">
              <a-popover>
                <template slot="content">
                  <LockanRadar
                    :no="record.no"
                    :data="record.data"
                    :data1="record.data1"
                    :indicator="record.indicator"
                  ></LockanRadar>
                </template>
                <a type="primary">
                  {{ record.totalScore }}
                </a>
              </a-popover>
            </span>
            <span slot="phoneNumber" slot-scope="text, record">
              <a-popover title="备用号码">
                <template slot="content">
                  <div style="overflow-y: auto; max-height: 250px; padding-right: 20px">
                    <p>{{ record.contactReserve }}</p>
                  </div>
                </template>
                <a type="primary">
                  {{ record.phoneNumber }}
                </a>
              </a-popover>
            </span>
          </a-table>
          <a-pagination
            show-size-changer
            show-quick-jumper
            :total="total"
            v-model="current"
            :pageSizeOptions="pageSizeOptions"
            :pageSize.sync="pageSize"
            @change="onChangePage"
            @showSizeChange="onShowSizeChange"
            :showTotal="(total) => `总共 ${total} 条`"
            style="text-align: right; margin: 10px 0 0 0"
          />
        </a-form>
      </div>
    </a-modal>
    <a-modal :mask="false" style="top: 20px" :width="650" v-model="chartRadarible" footer="">
      <div @click="clickMe" id="myChart" :style="{ width: '500px', height: '500px', marginLeft: '50px' }"></div>
    </a-modal>

    <requirements-enterprise-model ref="requirements"></requirements-enterprise-model>
    <enterprise-details ref="details"></enterprise-details>
  </div>
</template>

<script>
import { getdemandlist, getselectCombox } from '@/api/order/NewlyaddedOrderList'
import { LockanRadar } from '@/components'
import EnterpriseDetails from '@/views/enterprise/EnterpriseDetails'
import requirementsEnterpriseModel from '@/views/order/modules/requirementsEnterpriseModel'
import pick from 'lodash.pick'
import store from '@/store'
import { getselectAllProvince, getselectCityName, getselectAreaName, getfinddictAll } from '@/api/order/orderList'
import {
  getselectAreaPrincipalList,
  getselectAreaPrincipalByCityId,
  getselectPriceName,
  getmasterList,
  getupdateOrderMasterInfo,
  gethistoryMaster,
  getselectPriceNameForFirstPage,
  getmasterListForFirstPage
} from '@/api/order/leafletsDistribute'

export default {
  name: 'AmountEnterprise',
  components: {
    EnterpriseDetails,
    LockanRadar,
    requirementsEnterpriseModel,
    // editOrderModel,
    editOrderModel: () => import('@/views/order/modules/editOrderModel')
    // 注册弹框组件
  },
  data () {
    return {
      peopletype: '',
      total: 0,
      pageSize: 10,
      pageNum: 1,
      pageSizeOptions: ['10', '20', '30', '40', '50'],
      current: 1,
      amountEnterpriseible: false,
      form: this.$form.createForm(this),
      selectCombox: [],
      labelCol: { xs: { span: 24 }, sm: { span: 5 } },
      wrapperCol: { xs: { span: 24 }, sm: { span: 16 } },
      dividerdis: false,
      leafletsible: false,
      searchParam: '',
      chartRadarible: false,
      enterpriseId: '',
      installType: '',
      distributedata: [],
      distributecolumns: [
        {
          title: '序号',
          dataIndex: 'no',
          align: 'center'
        },
        {
          title: '姓名',
          dataIndex: 'name',
          align: 'center'
        },
        {
          title: '联系方式',
          dataIndex: 'phoneNumber',
          scopedSlots: { customRender: 'phoneNumber' },
          align: 'center'
        },
        {
          title: '师傅类型',
          dataIndex: 'type',
          align: 'center'
        },
        {
          title: '师傅负责人',
          dataIndex: 'masterLeadingName'
        },
        {
          title: '备注',
          dataIndex: 'remark'
        },
        {
          title: '提现周期',
          dataIndex: 'cashCycle',
          align: 'center'
        },
        {
          title: '近30天接单',
          dataIndex: 'orderNumIn30Days',
          align: 'center'
        }
      ],
      distributecolumnsLast: [,
        {
          title: '未销单',
          dataIndex: 'installOrderNo',
          align: 'center'
        },
        {
          title: '等级',
          dataIndex: 'level',
          align: 'center'
        },
        {
          title: '标签',
          dataIndex: 'label',
          align: 'center'
        },
        {
          title: '得分',
          dataIndex: 'totalScore',
          scopedSlots: { customRender: 'totalScore' },
          align: 'center'
        },
        {
          title: '提现方式',
          dataIndex: 'cashStatus',
          align: 'center'
        },
        {
          title: '接单方式',
          dataIndex: 'receiptType',
          align: 'center'
        },
        {
          title: '平台',
          dataIndex: 'platform',
          align: 'center'
        }
      ],
      selectAllProvince: [],
      selectCityName: [],
      selectAreaName: [],
      installTypes: [],
      reslist: '',
      columns: [
        {
          title: '序号',
          customRender: (text, record, index) => `${index + 1}`,
          align: 'center'
        },
        {
          title: '金额类型',
          dataIndex: 'priceType',
          align: 'center'
        },
        {
          title: '数量',
          dataIndex: 'number',
          align: 'center'
        },
        {
          title: '初始单价',
          dataIndex: 'initialPrice',
          align: 'center'
        },
        {
          title: '初始金额',
          dataIndex: 'initialAmount',
          align: 'center'
        },
        {
          title: '修改金额',
          dataIndex: 'changeAmount',
          align: 'center'
        },
        {
          title: '现订单金额',
          dataIndex: 'nowAmount',
          align: 'center'
        },
        {
          title: '金额备注',
          dataIndex: 'priceRemark',
          align: 'center'
        }
      ],
      showchartrecord: '',
      enterpriseamount: false,
      dispatchdemandlist: []
    }
  },
  methods: {
    // 分页
    onChangePage (page, pageNumber) {
      // this.current = page
      // console.log(page,pageNumber)
      this.pageNum = page
      getmasterListForFirstPage({
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        installType: this.form.getFieldValue('installType'),
        provinceId: this.form.getFieldValue('provinceId'),
        nameOrPhone: this.form.getFieldValue('nameOrPhone'),
        cityId: this.form.getFieldValue('cityId'),
        districtId: this.form.getFieldValue('countyId')
      }).then((res) => {
        if (res.code === 0) {
          // console.log(res.rows)
          this.distributedata = []
          this.total = res.total
          res.rows.forEach((item) => {
            // console.log({...item,...item.priceMap})
            item = { ...item, ...item.priceMap }
            this.distributedata.push(item)
          })
          // this.distributedata=res.rows
          // console.log(this.distributedata)
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    onShowSizeChange (current, pageSize) {
      // console.log(current, pageSize)
      this.pageSize = pageSize
      this.pageNum = current
      getmasterListForFirstPage({
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        installType: this.form.getFieldValue('installType'),
        provinceId: this.form.getFieldValue('provinceId'),
        nameOrPhone: this.form.getFieldValue('nameOrPhone'),
        cityId: this.form.getFieldValue('cityId'),
        districtId: this.form.getFieldValue('countyId')
      }).then((res) => {
        if (res.code === 0) {
          // console.log(res.rows)
          this.distributedata = []
          this.total = res.total
          res.rows.forEach((item) => {
            // console.log({...item,...item.priceMap})
            item = { ...item, ...item.priceMap }
            this.distributedata.push(item)
          })
          // this.distributedata=res.rows
          // console.log(this.distributedata)
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 安装类别
    getinstallType (e) {
      this.distributecolumns = [
        {
          title: '序号',
          dataIndex: 'no',
          align: 'center'
        },
        {
          title: '姓名',
          dataIndex: 'name',
          align: 'center'
        },
        {
          title: '联系方式',
          dataIndex: 'phoneNumber',
          scopedSlots: { customRender: 'phoneNumber' },
          align: 'center'
        },
        {
          title: '师傅类型',
          dataIndex: 'type',
          align: 'center'
        },
        {
          title: '师傅负责人',
          dataIndex: 'masterLeadingName'
        },
        {
          title: '标签',
          dataIndex: 'label',
          align: 'center'
        },
        {
          title: '备注',
          dataIndex: 'remark'
        },
        {
          title: '提现周期',
          dataIndex: 'cashCycle',
          align: 'center'
        },
        {
          title: '安装金额',
          dataIndex: 'installPrice',
          align: 'center'
        },
        {
          title: '维修金额',
          dataIndex: 'repairPrice',
          align: 'center'
        },
        {
          title: '近30天接单',
          dataIndex: 'orderNumIn30Days',
          align: 'center'
        }
      ]
      this.distributecolumnsLast = [,
        {
          title: '未销单',
          dataIndex: 'installOrderNo',
          align: 'center'
        },
        {
          title: '等级',
          dataIndex: 'level',
          align: 'center'
        },
        {
          title: '得分',
          dataIndex: 'totalScore',
          scopedSlots: { customRender: 'totalScore' },
          align: 'center'
        },
        {
          title: '提现方式',
          dataIndex: 'cashStatus',
          align: 'center'
        },
        {
          title: '接单方式',
          dataIndex: 'receiptType',
          align: 'center'
        },
        {
          title: '平台',
          dataIndex: 'platform',
          align: 'center'
        }
      ]
      getselectPriceNameForFirstPage({ installType: e }).then((res) => {
        if (res.code === 0) {
          this.distributecolumns = this.distributecolumns.concat(res.data.list, this.distributecolumnsLast)
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 查询师傅
    masterQuery () {
      this.form.validateFields((err, values) => {
        this.current = 1
        if (!err) {
          getmasterListForFirstPage({
            pageNum: 1,
            pageSize: this.pageSize,
            installType: this.form.getFieldValue('installType'),
            provinceId: this.form.getFieldValue('provinceId'),
            nameOrPhone: this.form.getFieldValue('nameOrPhone'),
            cityId: this.form.getFieldValue('cityId'),
            districtId: this.form.getFieldValue('countyId')
          }).then((res) => {
            if (res.code === 0) {
              // console.log(res.rows)
              this.distributedata = []
              this.total = res.total
              res.rows.forEach((item) => {
                // console.log({...item,...item.priceMap})
                item = { ...item, ...item.priceMap }
                this.distributedata.push(item)
              })
              // this.distributedata=res.rows
              // console.log(this.distributedata)
            } else {
              this.$message.error(res.msg)
            }
          })
        }
      })
    },
    // 安装类别
    async showcreeated () {
      const dictTypes = ['install_type']
      await getfinddictAll({ dictTypes: dictTypes.join() }).then((res) => {
        this.installTypes = res.install_type
      })
      this.getinstallType(this.installTypes[0].dictValue)
      this.selectAllProvince = []
      await getselectAllProvince().then((res) => {
        if (res.code === 0) {
          /* console.log('aaaaaaaaaaaaa') console.log(res) */
          this.selectAllProvince = res.rows
        } else {
          this.$message.error(res.msg)
        }
      })
      // 企业名称
      this.selectCombox = []
      getselectCombox().then((res) => {
        if (res.code === 0) {
          this.selectCombox = res.data
        } else {
          this.$message.error(res.msg)
        }
      })
      this.masterQuery()
    },
    async showleaflets (reslist) {
      this.form.resetFields()
      this.reslist = reslist
      if (this.reslist.orderId) {
        this.dividerdis = true
        this.leafletsible = true
        this.selectAreaName = []
        getselectAreaName({ cityCode: this.reslist.cityId }).then((res) => {
          if (res.code === 0) {
            this.selectAreaName = res.rows
          } else {
            this.$message.error(res.msg)
          }
        })
        // // 查询企业要求列表
        getdemandlist({
          demandType: 'dispatch_order_demand',
          model: this.reslist.modelId,
          orderType: this.reslist.orderType,
          enterpriseId: this.reslist.enterpriseId
        }).then((res) => {
          if (res.code === 0) {
            this.dispatchdemandlist = res.data.demandList.dispatch_order_demand
            // console.log(this.dispatchdemandlist)
          } else {
            this.$message.error(res.msg)
          }
        })

        await getmasterList({
          installType: this.reslist.installType,
          provinceId: this.reslist.provinceId,
          cityId: this.reslist.cityId,
          districtId: this.reslist.countyId,
          orderId: this.reslist.orderId
        }).then((res) => {
          if (res.code === 0) {
            this.distributedata = []
            res.rows.forEach((item) => {
              item = { ...item, ...item.priceMap }
              this.distributedata.push(item)
            })
            // this.distributedata=res.rows
            // console.log(this.distributedata)
            // this.drawLine();
          } else {
            this.$message.error(res.msg)
          }
        })
        this.selectCityName = []
        getselectCityName({ provinceCode: this.reslist.provinceId }).then((res) => {
          if (res.code === 0) {
            /* console.log(res) */
            this.selectCityName = res.rows
          } else {
            this.$message.error(res.msg)
          }
        })
        this.$nextTick(() => {
          this.form.setFieldsValue(
            pick(
              this.reslist,
              'brandName',
              'clientAddress',
              'clientName',
              'clientPhone',
              'areaPrincipal',
              'enterpriseSysName',
              'modelName',
              'totalAmount',
              'provinceId',
              'cityId',
              'countyId'
            )
          )
        })
      } else {
        this.dividerdis = false
        getselectPriceName({ orderIdList: this.reslist }).then((res) => {
          if (res.code === 0) {
            this.leafletsible = true
            this.distributecolumns = this.distributecolumns.concat(res.data.list, this.distributecolumnsLast)
            // 批量返回的数据
            this.searchParam = res.data.searchParam
            getmasterList({
              installType: res.data.searchParam.installType,
              provinceId: res.data.searchParam.provinceId,
              cityId: res.data.searchParam.cityId,
              districtId: res.data.searchParam.districtId
            }).then((res) => {
              if (res.code === 0) {
                this.distributedata = []
                res.rows.forEach((item) => {
                  item = { ...item, ...item.priceMap }
                  this.distributedata.push(item)
                })
                // this.distributedata=res.rows
                // console.log(this.distributedata)
                // this.drawLine();
              } else {
                this.$message.error(res.msg)
              }
            })
          } else {
            this.$message.error(res.msg)
          }
        })
      }
    },
    // 查看金额
    allViewamount () {
      this.$refs.details.edit(this.enterpriseId, '2', '0', '', 1)
    },
    // 企业要求
    allView () {
      // this.$refs.details.edit(this.enterpriseId,'1','0')
      console.log('1111', this.enterpriseId)
      this.$refs.requirements.showrequirement(this.enterpriseId, '33')
    },
    selectAreaNamechange (e) {
      getmasterList({
        installType: this.form.getFieldValue('installType'),
        provinceId: this.form.getFieldValue('provinceId'),
        cityId: this.form.getFieldValue('cityId'),
        districtId: e
      }).then((res) => {
        if (res.code === 0) {
          this.distributedata = []
          res.rows.forEach((item) => {
            item = { ...item, ...item.priceMap }
            this.distributedata.push(item)
          })
          // this.distributedata=res.rows
          // console.log(this.distributedata)
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    showchartRadar (record) {
      this.chartRadarible = true
      // this.showchartrecord=record
      this.$nextTick(function () {
        this.drawLine(record.indicator, record.data, record.data1)
      })
    },
    drawLine (indicator, data, data1) {
      // 基于准备好的dom，初始化echarts实例
      const myChart = this.$echarts.init(document.getElementById('myChart'))
      // let legenddata=[]
      //   data.forEach(item=>{
      //     legenddata.push(item.name)
      // })
      console.log(indicator, data)
      // 绘制图表
      myChart.setOption({
        title: {
          text: '雷达图'
        },
        tooltip: {},
        legend: {
          data1
        },
        radar: {
          // shape: 'circle',
          name: {
            textStyle: {
              color: '#fff',
              backgroundColor: '#999',
              borderRadius: 3,
              padding: [3, 5]
            }
          },
          indicator,
          center: ['50%', '50%'],
          radius: 80
        },
        series: [
          {
            // name: '预算 vs 开销（Budget vs spending）',
            type: 'radar',
            data
          }
        ]
      })
    },
    clickMe () {
      this.chartRadarible = false
    },
    offchartRadar () {
      // this.chartRadarible=false
    },
    /* 获取市 省更改 */
    getselect (e) {
      // if(e){
      getselectCityName({ provinceCode: e }).then((res) => {
        if (res.code === 0) {
          /* console.log(res) */
          this.selectCityName = res.rows
        } else {
          this.$message.error(res.msg)
        }
      })

      // }
      // getmasterList({
      //   installType: this.form.getFieldValue("installType"),
      //   provinceId: e,
      // }).then(res => {
      //   if (res.code === 0) {
      //     this.distributedata=[]
      //     res.rows.forEach(item => {
      //       item = {...item, ...item.priceMap}
      //       this.distributedata.push(item)
      //     })
      //     // this.distributedata=res.rows
      //     // console.log(this.distributedata)
      //   } else {
      //     this.$message.error(res.msg);
      //   }
      // })
      this.form.setFieldsValue({
        cityId: undefined
      })
      this.form.setFieldsValue({
        countyId: undefined
      })
    },
    /* 获取区 市更改 */
    getprovinceName (e) {
      // console.log(e)
      getselectAreaName({ cityCode: e }).then((res) => {
        if (res.code === 0) {
          /* console.log(res) */
          this.selectAreaName = res.rows
        } else {
          this.$message.error(res.msg)
        }
      })
      // getmasterList({
      //   installType: this.form.getFieldValue("installType"),
      //   provinceId: this.form.getFieldValue("provinceId"),
      //   cityId: e,
      // }).then(res => {
      //   if (res.code === 0) {
      //     this.distributedata=[]
      //     res.rows.forEach(item => {
      //       item = {...item, ...item.priceMap}
      //       this.distributedata.push(item)
      //     })
      //     // this.distributedata=res.rows
      //     // console.log(this.distributedata)
      //   } else {
      //     this.$message.error(res.msg);
      //   }
      // })
      this.form.setFieldsValue({
        countyId: undefined
      })
    },
    filterOption (input, option) {
      if (option) {
        return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      }
    },
    // 点击菜单搜索进入此页面
    showamountEnterprise () {
      this.showcreeated()
      this.leafletsible = true
      this.enterpriseId = undefined
    },
    amountEnterpriseibleSubmit () {}
  },
  async created () {
    this.peopletype = store.getters.userType
  }
}
</script>

<style scoped>
/deep/ .ant-table th {
  white-space: nowrap;
}
/deep/ .ant-table td {
  white-space: nowrap;
  padding: 6px 16px;
}
</style>
